// Components
import SectionHeader from 'components/SectionHeader'
import Card from './Card'

// Styles
import { Wrapper, FlexContainer, Items } from './style.js'

const Media = ({ media, medias }) => {
  const { title, description } = media?.data

  return (
    <Wrapper>
      <FlexContainer>
        <SectionHeader
          isFirstElement
          noPadding
          title={title}
          description={description}
        />
        <Items>
          {medias &&
            medias.map(({ title, data, text, slug }, index) => {
              const { card_image } = data

              return (
                <Card
                  key={index}
                  title={title}
                  card_image={card_image}
                  reverse={index % 2}
                  text={text}
                  slug={slug}
                />
              )
            })}
        </Items>
      </FlexContainer>
    </Wrapper>
  )
}

export default Media
